import { Instagram, Facebook } from "lucide-react";



export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative min-h-[400px] bg-espresso text-cream/75 border-t border-cream/10 overflow-hidden"
    >

      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-12 md:py-16 relative z-10">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2 leading-none">
              <span className="font-display italic text-3xl text-cream font-medium">
                Empório
              </span>
              <span className="font-mono text-[10px] tracking-[0.32em] uppercase text-gold">
                do café
              </span>
            </div>
            <p className="mt-5 max-w-md text-cream/60 text-sm leading-relaxed">
              Grãos especiais, queijos da Canastra, cachaças premiadas e doces
              artesanais — do primeiro aroma ao último gole, no coração de
              Alfenas / MG.
            </p>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-4">
              Visite
            </div>
            <div className="text-sm leading-relaxed">
              Praça Getúlio Vargas, 367<br />
              Centro · Alfenas / MG<br />
              Seg–Sex 8h–18h · Sáb 9h–18h
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-cream/50 mb-4">
              Siga
            </div>
            <div className="flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-espresso hover:border-gold transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-espresso hover:border-gold transition-colors"
              >
                <Facebook size={16} />
              </a>
              <a
                href="https://wa.me/5535999516948"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                data-testid="social-whatsapp"
                className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-gold hover:text-espresso hover:border-gold transition-colors"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-cream/45">
            © 2026 Empório do Café · Todos os direitos reservados
          </div>
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-cream/45">
            Feito pelo artista digital{" "}
            <span className="text-gold">Maycon Robert</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
